'use client';

import { forwardRef } from 'react';
import clsx from 'clsx';

import { useAccordionContext } from '../contexts/accordion-context';
import { useAccordionItemContext } from '../contexts/accordion-item-context';

interface AccordionBodyProps {
	as?: React.ElementType;
	className?: string;
	children: React.ReactNode;
}

export const AccordionBody = forwardRef<HTMLElement, AccordionBodyProps>(function AccordionBody(
	{
		as,
		className,
		children,
		...props
	},
	ref
) {
	const Component = as || 'div';
	const { isAccordionItemExpanded } = useAccordionContext();
	const { itemKey } = useAccordionItemContext();
	const isExpanded = isAccordionItemExpanded(itemKey);

	return isExpanded ? (
		<Component 
			ref={ref}
			className={clsx('accordion__body', className)}
			{...props}
		>
			{children}
		</Component>
	) : null;
});